const Views = () => ({});

export default Views;
